import 'intl-tel-input/build/js/utils.js'
import isEmail from '../js/is_email.js'
import add_invalid_feedback from '../js/add_invalid_feedback.js'
import remove_invalid_feedback from '../js/remove_invalid_feedback.js'
import '../js/logo_dropzone.js'
import '../js/institution_feature_image_dropzone.js' 
import '../js/quill_no_img.js'
import '../js/countrySelect.js'
import 'select2/dist/js/select2.min.js'
import '../js/select2.js'
import uncoverPassword from '../js/uncover_password.js'
window.uncoverPassword = uncoverPassword

document.addEventListener("DOMContentLoaded",function(){
  $("[data-form-prepend]").click(function(e) {
    var obj = $($(this).attr("data-form-prepend"));
    obj.find("input, select, textarea").each(function() {
      $(this).attr("name", function() {
        return $(this)
          .attr("name")
          .replace("new_record", new Date().getTime());
      });
        });
    obj.insertBefore(this);
    return false;
  }); 

  // Getting Country data from HTTP header
  var visitor_country = $("#visitor-country").data('visitor-country') || "my" ;

  // User Sign Up form
  // Initializing Phone Number with country
  if ($("#telephone").length) {
  	var input = document.querySelector("#telephone");
    var user_telephone_iti = intlTelInput(input, {
      initialCountry: visitor_country,
      autoPlaceholder: "off",
      separateDialCode: true,
      customContainer: "w-100",
      preferredCountries: ["my","sg"] ,
      utilsScript: "../intl-tel-input/build/js/utils.js"
    });

    if($("#telephone").val() != ""){
      user_telephone_iti.setNumber($("#telephone").val());
    }
  }

  if ($("#user_first_name").length) {
    $("#user_first_name").change(function() {
      remove_invalid_feedback("#user_first_name","#UserFirstNameInvalidFeedback");
    });
  }

  if ($("#user_last_name").length) {
    $("#user_last_name").change(function() {
      remove_invalid_feedback("#user_last_name","#UserLastNameInvalidFeedback");
    });
  }

  if ($("#user_email").length) {
    $("#user_email").change(function() {
      remove_invalid_feedback("#user_email","#UserEmailInvalidFeedback");

      if(!isEmail($("#user_email").val())){
        add_invalid_feedback("#user_email","#UserEmailInvalidFeedback",null,"Invalid email");
      }
    });
  }

  if ($("#telephone").length) {
    $("#telephone").change(function() {
      if(!user_telephone_iti.isValidNumber()){
        add_invalid_feedback("#telephone","#TelephoneInvalidFeedback","telephone","Invalid phone number");
      }else{
        remove_invalid_feedback("#telephone","#TelephoneInvalidFeedback");
      }
    });
  }

  if ($("#user_password").length) {
    $("#user_password").change(function() {
      remove_invalid_feedback("#user_password","#UserPasswordInvalidFeedback");
    });
  }

  if ($("#user_password_confirmation").length) {
    $("#user_password_confirmation").change(function() {
      remove_invalid_feedback("#user_password_confirmation","#UserPasswordConfirmationInvalidFeedback");
    });
  }

  $('#UserUpdateBtn').click(function(e){
    e.preventDefault();

    var user_first_name_check = true;
    var user_last_name_check = true;
    var user_email_check = true;
    var user_telephone_check = true;

    if(jQuery.trim($('#user_first_name').val()) == ""){
      add_invalid_feedback("#user_first_name","#UserFirstNameInvalidFeedback");
      user_first_name_check = false;
    }

    if(jQuery.trim($('#user_last_name').val()) == ""){
      add_invalid_feedback("#user_last_name","#UserLastNameInvalidFeedback");
      user_last_name_check = false;
    }

    if(jQuery.trim($('#user_email').val()) == ""){
      add_invalid_feedback("#user_email","#UserEmailInvalidFeedback");
      user_email_check = false;
    }

    if(jQuery.trim($('#telephone').val()) == ""){
      add_invalid_feedback("#telephone","#TelephoneInvalidFeedback","telephone");
      user_telephone_check = false;
    }else{
      if(!user_telephone_iti.isValidNumber()){
        add_invalid_feedback("#telephone","#TelephoneInvalidFeedback","telephone","Invalid phone number");
        user_telephone_check = false;
      }else{
        remove_invalid_feedback("#telephone","#TelephoneInvalidFeedback");
        $("#telephone").val(user_telephone_iti.getNumber());
        user_telephone_check = true;
      }
    }

    if(user_first_name_check && user_last_name_check && user_email_check && user_telephone_check){
      $('#edit_user').submit();
    }
  });

  $('#UserSignUpBtn').click(function(e){
    e.preventDefault();

    var user_first_name_check = true;
    var user_last_name_check = true;
    var user_email_check = true;
    var user_telephone_check = true;
    var user_password_check = true;
    var user_password_confirmation_check = true;

    if(jQuery.trim($('#user_first_name').val()) == ""){
      add_invalid_feedback("#user_first_name","#UserFirstNameInvalidFeedback");
      user_first_name_check = false;
    }

    if(jQuery.trim($('#user_last_name').val()) == ""){
      add_invalid_feedback("#user_last_name","#UserLastNameInvalidFeedback");
      user_last_name_check = false;
    }

    if(jQuery.trim($('#user_email').val()) == ""){
      add_invalid_feedback("#user_email","#UserEmailInvalidFeedback");
      user_email_check = false;
    }

    if(jQuery.trim($('#telephone').val()) == ""){
      add_invalid_feedback("#telephone","#TelephoneInvalidFeedback","telephone");
      user_telephone_check = false;
    }else{
      if(!user_telephone_iti.isValidNumber()){
        add_invalid_feedback("#telephone","#TelephoneInvalidFeedback","telephone","Invalid phone number");
        user_telephone_check = false;
      }else{
        remove_invalid_feedback("#telephone","#TelephoneInvalidFeedback");
        $("#telephone").val(user_telephone_iti.getNumber());
        user_telephone_check = true;
      }
    }

    if(jQuery.trim($('#user_password').val()) == ""){
      add_invalid_feedback("#user_password","#UserPasswordInvalidFeedback");
      user_password_check = false;
    }else{
      if($('#user_password').val() != $('#user_password_confirmation').val()){
        add_invalid_feedback("#user_password_confirmation","#UserPasswordConfirmationInvalidFeedback",null,"password confirmation is not the same as password");
        user_password_confirmation_check = false;
      }
    }

    if(jQuery.trim($('#user_password_confirmation').val()) == ""){
      add_invalid_feedback("#user_password_confirmation","#UserPasswordConfirmationInvalidFeedback");
      user_password_confirmation_check = false;
    }else{
      if($('#user_password').val() != $('#user_password_confirmation').val()){
        add_invalid_feedback("#user_password_confirmation","#UserPasswordConfirmationInvalidFeedback",null,"password confirmation is not the same as password");
        user_password_confirmation_check = false;
      }
    }

    if(user_first_name_check && user_last_name_check && user_email_check && user_telephone_check && user_password_check && user_password_confirmation_check){
      $('#new_user').submit();
    }
  });

  // Institution Sign Up form
  // Initializing Fax Number with country
  if ($("#fax").length) {
    var input = document.querySelector("#fax");
    var fax_iti = intlTelInput(input, {
      initialCountry: visitor_country,
      autoPlaceholder: "off",
      separateDialCode: true,
      customContainer: "w-100",
      preferredCountries: ["my","sg"] ,
      utilsScript: "../intl-tel-input/build/js/utils.js"
    });
    if($("#fax").val() != ""){
      fax_iti.setNumber($("#fax").val());
    }
  }


  //Initialise Country Dropdown for selection
  if ($("#country_select").length) {
  	$("#country_select").countrySelect({
  		defaultCountry: $("#ServerCountrySelectCode").text() || visitor_country.toLowerCase(),
  		preferredCountries: [],
  		responsiveDropdown: true
  	});
  }

  // Add red border to Institution Logo dropzone if there is error
  if ($("#InstitutionLogoInvalidFeedback").length) {
  	$("#InstitutionLogoDropzone").find(".dz-message").addClass("border-danger");
  }

  // Add red border to Insitution Profile Container if there is error
  if ($("#InstitutionProfileInvalidFeedback").length) {
  	$("#InstitutionProfileContainer .ql-editor").addClass("border-danger");
  }

  if ($("#institution_name").length) {
  	$('#institution_name').change(function(){
  		$("#InstitutionNameInvalidFeedback").remove();
  		$('#institution_name').removeClass("is-invalid");
  	});
  }

  //Initialise Rich text edit for Institution Profiles
  if ($("#InstitutionProfileContainer").length) {
    var ql_container = document.querySelector("#InstitutionProfileContainer");
    var institution_profile_container = Quill.find(ql_container); 
    institution_profile_container.root.innerHTML=$("#institution_description").val();
    institution_profile_container.on('editor-change', function(eventName) {
      var temp_value = institution_profile_container.root.innerHTML;

      if(jQuery.trim($(temp_value).text())!=""){
        if($("#InstitutionProfileInvalidFeedback").length){
          $("#InstitutionProfileInvalidFeedback").remove();
        }
        $("#InstitutionProfileContainer .ql-editor").removeClass("border-danger");
      }
      $("#institution_description").val(temp_value);
    });
  }

  if ($("#institution_addr_first_line").length) {
  	$('#institution_addr_first_line').change(function(){
  		$("#InstitutionAddrFirstInvalidFeedback").remove();
  		$('#institution_addr_first_line').removeClass("is-invalid");
  	});
  }

  if ($("#institution_post_code").length) {
  	$('#institution_post_code').change(function(){
  		$("#InstitutionPostCodeInvalidFeedback").remove();
  		$('#institution_post_code').removeClass("is-invalid");
  	});
  }

  if ($("#institution_state").length) {
  	$('#institution_state').change(function(){
  		$("#InstitutionStateInvalidFeedback").remove();
  		$('#institution_state').removeClass("is-invalid");
  	});
  }

  if ($("#institution_website").length) {
  	$('#institution_website').change(function(){
  		$("#InstitutionWebsiteInvalidFeedback").remove();
  		$('#institution_website').removeClass("is-invalid");
  	});
  }

  $('#InstitutionSubmitBtn').click(function(e){
  	e.preventDefault();

    var institution_name_check = true;
    var institution_logo_check = true;
    var institution_description_check = true;
    var institution_addr_first_line_check = true;
    var institution_post_code_check = true;
    var institution_state_check = true;
    var institution_phone_check = true;
    var institution_website_check = true;

    if(jQuery.trim($('#institution_name').val()) == ""){
      add_invalid_feedback("#institution_name",'#InstitutionNameInvalidFeedback');
      institution_name_check = false;
    }

    if($("input[name='logo_blob']").length == 0 && $("#server_institution_logo").length == 0){
      if ($('#InstitutionLogoInvalidFeedback').length == 0){
        $("#InstitutionLogoDropzone").find(".dz-message").addClass("border-danger");
        $("#InstitutionLogoDropzone").append("<div id='InstitutionLogoInvalidFeedback' class='invalid-feedback'>cannot be blank</div");
      }
      institution_logo_check = false;
    }

    if(jQuery.trim($("#institution_description").val())==""){
      $("#InstitutionProfileContainer .ql-editor").addClass("border-danger");
      if ($('#InstitutionProfileInvalidFeedback').length){
        $("#InstitutionProfileInvalidFeedback").text("cannot be blank");
      }else{
         $("#InstitutionProfileContainer").append("<div id='InstitutionProfileInvalidFeedback' class='invalid-feedback'>cannot be blank</div>");
      }
      institution_description_check = false;
    }

    if(jQuery.trim($('#institution_addr_first_line').val()) == ""){
      add_invalid_feedback("#institution_addr_first_line",'#InstitutionAddrFirstInvalidFeedback');
      institution_addr_first_line_check = false;
    }

    if(jQuery.trim($('#institution_post_code').val()) == ""){
      add_invalid_feedback("#institution_post_code",'#InstitutionPostCodeInvalidFeedback');
      $("#institution_post_code").addClass("is-invalid");
      institution_post_code_check = false;
    }

    if(jQuery.trim($('#institution_state').val()) == ""){
      add_invalid_feedback("#institution_state",'#InstitutionStateInvalidFeedback');
      institution_state_check = false;
    }

    if(jQuery.trim($('#telephone').val()) == ""){
      add_invalid_feedback("#telephone","#TelephoneInvalidFeedback","telephone");
      institution_phone_check = false;
    }else{
      if(!user_telephone_iti.isValidNumber()){
        add_invalid_feedback("#telephone","#TelephoneInvalidFeedback","telephone","Invalid phone number");
        institution_phone_check = false;
      }else{
        remove_invalid_feedback("#telephone","#TelephoneInvalidFeedback");
        $("#telephone").val(user_telephone_iti.getNumber());
        institution_phone_check = true;
      }
    }

    if(jQuery.trim($('#institution_website').val()) == ""){
      add_invalid_feedback("#institution_website",'#InstitutionWebsiteInvalidFeedback');
      institution_website_check = false;
    }

    if(institution_name_check && institution_logo_check && institution_description_check && institution_addr_first_line_check && institution_post_code_check && institution_state_check && institution_phone_check && institution_website_check){
    	$('#InstitutionForm').submit();
    }
  });

  //Check if TNC is clicked
  if ($("#tnc_checkbox").length) {
    $("#tnc_checkbox").change(function() {
        if(this.checked) {
            $("#submit_form_btn").removeClass("btn-secondary").addClass("btn-primary").prop("disabled", false);
        }
        else{
          $("#submit_form_btn").addClass("btn-secondary").removeClass("btn-primary").prop("disabled", true);
        }

    });
  }
});